module.exports = __webpack_public_path__ + "5be5fbcb55c0d12f61f03fd603c2ddd2.png";